export interface DataSourceItem {
  id?: string;
  platform: string;
  url: string;
  branch?: string;
  mcp_config?: string;
  organization?: string;
  scope?: string;
  userId?: string;
  mcp_mappings?: string;
  languages?: string[];
  frameworks?: string[];
  buildTools?: string[];
  criticality?: string;
  type?: string;
}

export const REPO_LANGUAGE_OPTIONS = ['Java', 'TypeScript', 'JavaScript', 'Python', 'Go', 'Kotlin', 'C#', 'C++', 'Rust'];
export const REPO_FRAMEWORK_OPTIONS = ['Spring Boot', 'React', 'Angular', 'Vue', 'Next.js', 'Express', 'Django', 'Flask', '.NET'];
export const REPO_BUILD_TOOL_OPTIONS = ['Gradle', 'Maven', 'Vite', 'Webpack', 'npm', 'Yarn', 'pnpm', 'Bazel'];
export const REPO_CRITICALITY_OPTIONS = ['HIGH', 'MEDIUM', 'LOW'];
export const REPO_TYPE_OPTIONS = ['INFRA', 'NON_INFRA'];


export const extractBaseUrl = (rawUrl: string): string => {
  try {
    const urlObj = new URL(rawUrl.trim());
    return `${urlObj.protocol}//${urlObj.host}`;
  } catch {
    return rawUrl.trim();
  }
};
